import React from 'react';
import { useTranslation } from 'react-i18next';
import DOMPurify from 'dompurify';

const WebVisitorContent: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="web-visitor-content">
      <div className="datenschutz-container">
        <section className="datenschutz-section">
          <h2>1. {t('webVisitorOverview')}</h2>
          <div className="datenschutz-content">
            <h3>{t('webVisitorGeneral')}</h3>
            <p>{t('webVisitorGeneralText')}</p>

            <h3>{t('webVisitorApplicable')}</h3>
            <p>{t('webVisitorWebsite')}</p>

            <h3 dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(t('webVisitorDataCollection')) }}></h3>
            <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(t('webVisitorResponsibleText')) }}></p>
            <h3>{t('webVisitorHowWeCollect')}</h3>
            <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(t('webVisitorHowWeCollectText')) }}></p>
            <h3>{t('webVisitorWhyWeUse')}</h3>
            <p>{t('webVisitorWhyWeUseText')}</p>
            <h3>{t('webVisitorYourRights')}</h3>
            <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(t('webVisitorYourRightsText')) }}></p>
            <h3>{t('webVisitorAnalysisTools')}</h3>
            <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(t('webVisitorAnalysisToolsText')) }}></p>
          </div>
        </section>
        <section className="datenschutz-section">
          <h2>2. {t('webVisitorGeneralNotes')}</h2>
          <div className="datenschutz-content">
            <h3>{t('webVisitorPrivacy')}</h3>
            <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(t('webVisitorPrivacyText')) }}></p>

            <h3>{t('webVisitorResponsibleEntity')}</h3>
            <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(t('webVisitorResponsibleEntityText')) }}></p>

            <h3>{t('webVisitorWithdrawConsent')}</h3>
            <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(t('webVisitorWithdrawConsentText')) }}></p>

            <h3>{t('webVisitorRightToObject')}</h3>
            <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(t('webVisitorRightToObjectText')) }}></p>
            
            <h3>{t('webVisitorComplaintRight')}</h3>
            <p>{t('webVisitorComplaintRightText')}</p>
            
            <h3>{t('webVisitorDataPortability')}</h3>
            <p>{t('webVisitorDataPortabilityText')}</p>
            
            <h3>{t('webVisitorSSLEncryption')}</h3>
            <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(t('webVisitorSSLEncryptionText')) }}></p>
            
            <h3>{t('webVisitorAccessBlockDelete')}</h3>
            <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(t('webVisitorAccessBlockDeleteText')) }}></p>
            
            <h3>{t('webVisitorRestrictionRight')}</h3>
            <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(t('webVisitorRestrictionRightText')) }}></p>
            
            <h3>{t('webVisitorObjectAdvertising')}</h3>
            <p>{t('webVisitorObjectAdvertisingText')}</p>
          </div>
        </section>

        <section className="datenschutz-section">
          <h2>3. {t('webVisitorDataProtectionOfficer')}</h2>
          <div className="datenschutz-content">
            <h3>{t('webVisitorStatutoryOfficer')}</h3>
            <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(t('webVisitorStatutoryOfficerText')) }}></p>
          </div>
        </section>

        <section className="datenschutz-section">
          <h2>4. {t('webVisitorDataCollectionWebsite')}</h2>
          <p>{t('webVisitorDataCollectionWebsiteText')}</p>
          <div className="datenschutz-content">
            <h3>4.1 {t('webVisitorInternetUsers')}</h3>
            <h3>{t('webVisitorCookies')}</h3>
            <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(t('webVisitorCookiesText')) }}></p>
            
            <h3>{t('webVisitorServerLogFiles')}</h3>
            <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(t('webVisitorServerLogFilesText')) }}></p>

            <h3>{t('webVisitorContactForm')}</h3>
            <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(t('webVisitorContactFormText')) }}></p>
            
            <h3>4.2 {t('webVisitorInterestedParties')}</h3>
            <p>{t('webVisitorInterestedPartiesText')}</p>
            
            <h3>4.3 {t('webVisitorEmployeesApplicants')}</h3>
            <p>{t('webVisitorEmployeesApplicantsText')}</p>
          </div>
        </section>

        <section className="datenschutz-section">
          <h2>5. {t('webVisitorAnalysisAdvertising')}</h2>
          <div className="datenschutz-content">
            <h3>{t('webVisitorAnalytics')}</h3>
            <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(t('webVisitorAnalyticsText')) }}></p>
            
            <h3>{t('webVisitorBrowserPlugin')}</h3>
            <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(t('webVisitorBrowserPluginText')) }}></p>
            
            <h3>{t('webVisitorObjectDataCollection')}</h3>
            <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(t('webVisitorObjectDataCollectionText')) }}></p>
            
            <h3>{t('webVisitorWordPressStats')}</h3>
            <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(t('webVisitorWordPressStatsText')) }}></p>
          </div>
        </section>
        
        <section className="datenschutz-section">
          <h2>6. {t('webVisitorNewsletter')}</h2>
          <div className="datenschutz-content">
            <h3>{t('webVisitorNewsletterData')}</h3>
            <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(t('webVisitorNewsletterDataText')) }}></p>
          </div>
        </section>

        <section className="datenschutz-section">
          <h2>7. {t('webVisitorPluginsTools')}</h2>
          <div className="datenschutz-content">
            <h3>{t('webVisitorYouTube')}</h3>
            <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(t('webVisitorYouTubeText')) }}></p>
            
            <h3>{t('webVisitorGoogleMaps')}</h3>
            <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(t('webVisitorGoogleMapsText')) }}></p>
          </div>
        </section>
        
        <section className="datenschutz-section">
          <h2>8. {t('webVisitorFurtherInfo')}</h2>
          <div className="datenschutz-content">
            <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(t('webVisitorFurtherInfoText')) }}></p>
          </div>
        </section>
      </div>
    </div>
  );
};

export default WebVisitorContent;
